import React from "react";
import './OurVision.css';
import Bluepill from '../AboutImages/bluepill.png'

// images
import Visiondna from '../AboutImages/visiondna.png';
import Bluemicroscope from '../AboutImages/bluemicroscope.png';


function OurVision(){
    return(
        <>
            <div className="aboutus-ourvision">
                <div className="aboutus-ourvision-con">
                    {/* part1 */}
                    <div className="ourvision-img-con">
                        <div className="ourvision-dna-con">
                            <div className="ourvision-dna-img">
                                <img src={Visiondna} alt='our vision dna'/>
                            </div>
                        </div>
                        <div className="ourvision-bluemicroscope">
                            <img src={Bluemicroscope} alt='our vision'/>
                        </div>
                    </div>
                    {/* part 2 */}
                    <div className="aboutus-ourmission-one">
                        <div className="aboutus-ourmission-one-img">
                            <img src={Bluepill} alt='bluepill' />
                        </div>
                        <div className="aboutus-ourmission-one-1">
                            <h2>Our vision</h2>
                            <h3>Arde’s Vision: To be recognized as a leading pharmaceutical provider, known for delivering affordable, innovative medicines globally.</h3>
                            <p>
                                Arde’s vision is to establish itself as a trusted leader in the pharmaceutical industry, known for its commitment to affordability and innovation. By prioritizing accessible, high-quality medicines, we aim to meet global healthcare needs effectively. Our dedication to excellence ensures we deliver impactful health solutions worldwide.
                            </p>
                        </div>
                    </div>
                </div>
                {/* blur background */}
                <div className="aboutus-ourvision-backgoundblur"></div>
            </div>
        </>
    );
}

export default OurVision;